/* -----------------Third parties--------------- */
import { useState } from "react";
import { DatePickerModal, TimePickerModal } from "react-native-paper-dates";

interface DateTimePickerModalProps {
	isVisible: boolean;
	mode?: "date" | "time" | "datetime";
	onConfirm: (date: Date) => void;
	onCancel: () => void;
	date?: Date;
	minimumDate?: Date;
	label?: string;
	saveLabel?: string;
}

const DateTimePickerModal = ({
	isVisible,
	onConfirm,
	onCancel,
	date,
	mode = "datetime",
	minimumDate,
	label = "Select date",
	saveLabel,
}: DateTimePickerModalProps) => {
	const [showDatePicker, setShowDatePicker] = useState(mode !== "time");
	const [showTimePicker, setShowTimePicker] = useState(mode === "time");
	const [selectedDate, setSelectedDate] = useState<Date | undefined>(date);

	const handleDateConfirm = (params: unknown) => {
		const singleParams = params as { date?: Date };
		if (singleParams.date) {
			setSelectedDate(singleParams.date);
			setShowDatePicker(false);
			if (mode === "datetime") {
				setShowTimePicker(true);
			} else {
				onConfirm(singleParams.date);
			}
		}
	};

	const handleTimeConfirm = ({
		hours,
		minutes,
	}: { hours: number; minutes: number }) => {
		if (selectedDate || mode === "time") {
			const finalDateTime = selectedDate ? new Date(selectedDate) : new Date();
			finalDateTime.setHours(hours, minutes, 0, 0);
			onConfirm(finalDateTime);
		}
		if (mode === "datetime") {
			setShowDatePicker(true);
		}
		setShowTimePicker(false);
	};

	const handleCancel = () => {
		setShowDatePicker(mode !== "time");
		setShowTimePicker(mode === "time");
		onCancel();
	};

	if (!isVisible) {
		return null;
	}

	const getDefaultSaveLabel = () => {
		if (saveLabel) {
			return saveLabel;
		}
		return mode === "date" ? "Set date" : "Next";
	};

	return (
		<>
			{mode !== "time" && (
				<DatePickerModal
					visible={showDatePicker}
					onDismiss={handleCancel}
					onConfirm={handleDateConfirm}
					date={selectedDate}
					mode="single"
					locale="en"
					label={label}
					saveLabel={getDefaultSaveLabel()}
					validRange={{ startDate: minimumDate }}
				/>
			)}
			{(mode === "time" || mode === "datetime") && (
				<TimePickerModal
					visible={showTimePicker}
					use24HourClock={false}
					onDismiss={handleCancel}
					cancelLabel="Cancel"
					confirmLabel="Set time"
					onConfirm={handleTimeConfirm}
					hours={selectedDate ? selectedDate.getHours() : 14}
					minutes={selectedDate ? selectedDate.getMinutes() : 30}
				/>
			)}
		</>
	);
};

export default DateTimePickerModal;
